export default __webpack_public_path__ + "f26e3354f23133eea0d23a1f00c71253.png";